var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoTinacoAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_nidos_de_lluvia",
    "data-name": "ico_nidos de lluvia",
    transform: "translate(-306 -896)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6451",
    "data-name": "Rectangle 6451",
    width: 22,
    height: 22,
    transform: "translate(306 896)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8285",
    "data-name": "Group 8285",
    transform: "translate(309.542 897.131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19958",
    "data-name": "Path 19958",
    d: "M163.765,91.323a20.292,20.292,0,0,1-5.591-.8A1.953,1.953,0,0,1,156.8,88.63V77.708a1.947,1.947,0,0,1,.828-1.62l3.007-2.1a.378.378,0,0,1,.2-.063h5.853a.331.331,0,0,1,.2.063l3.007,2.1a1.948,1.948,0,0,1,.828,1.62V88.63a1.953,1.953,0,0,1-1.372,1.894,20.29,20.29,0,0,1-5.591.8ZM160.96,74.678l-2.906,2.041a1.2,1.2,0,0,0-.5.989V88.63a1.206,1.206,0,0,0,.848,1.157,19.161,19.161,0,0,0,10.778,0,1.187,1.187,0,0,0,.848-1.157V77.708a1.169,1.169,0,0,0-.5-.989l-2.906-2.041Z",
    transform: "translate(-155.812 -71.585)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19959",
    "data-name": "Path 19959",
    d: "M266.539,35.809h-7.36a.455.455,0,0,1-.457-.457V33.728a.465.465,0,0,1,.406-.457,30.587,30.587,0,0,1,7.462,0,.465.465,0,0,1,.406.457v1.624a.455.455,0,0,1-.457.457Zm-6.9-.913h6.421V34.16a30.176,30.176,0,0,0-6.421,0Z",
    transform: "translate(-255.079 -32.56)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19960",
    "data-name": "Path 19960",
    d: "M166.287,154.582h-.051c-.787-.076-1.574-.152-2.36-.279a.46.46,0,1,1,.1-.914c.761.1,1.548.2,2.335.254a.458.458,0,0,1,.406.508.428.428,0,0,1-.431.431Z",
    transform: "translate(-162.175 -148.412)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19961",
    "data-name": "Path 19961",
    d: "M262.277,155.394c-1.244,0-2.487-.051-3.731-.127a.458.458,0,1,1,.051-.914,61.108,61.108,0,0,0,11.6-.406.46.46,0,0,1,.1.914,60.241,60.241,0,0,1-8.02.533Z",
    transform: "translate(-256.117 -148.96)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19962",
    "data-name": "Path 19962",
    d: "M283.774,23.442a.467.467,0,0,1-.457-.431.478.478,0,0,1,.431-.508c.584-.051,1.142-.076,1.675-.1a.47.47,0,1,1,.026.939c-.533.025-1.041.051-1.624.1h-.051Z",
    transform: "translate(-278.106 -22.402)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19963",
    "data-name": "Path 19963",
    d: "M361.653,23.442H361.6c-.584-.051-1.117-.076-1.624-.1A.47.47,0,1,1,360,22.4c.533.025,1.091.051,1.675.1a.5.5,0,0,1,.431.508.467.467,0,0,1-.457.431Z",
    transform: "translate(-351.637 -22.402)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19964",
    "data-name": "Path 19964",
    d: "M285.46,256.7a7.689,7.689,0,0,0-1.345-1.345.724.724,0,0,0-.837,0l-.025.025a9.09,9.09,0,0,0-1.32,1.32,5.486,5.486,0,0,0-1.37,3.426,3.123,3.123,0,1,0,6.243,0,5.357,5.357,0,0,0-1.345-3.426Zm.482,3.4a2.234,2.234,0,1,1-4.467,0,4.589,4.589,0,0,1,1.193-2.843,8.214,8.214,0,0,1,1.066-1.091,8.814,8.814,0,0,1,1.066,1.091,4.869,4.869,0,0,1,1.142,2.843Z",
    transform: "translate(-275.893 -247.153)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19965",
    "data-name": "Path 19965",
    d: "M136.2,412.1h-.888a.347.347,0,0,1-.355-.355v-1.472a.347.347,0,0,1,.355-.355h.888a.355.355,0,1,1,0,.711h-.533v.761h.533a.347.347,0,0,1,.355.355.381.381,0,0,1-.355.355Z",
    transform: "translate(-134.958 -395.336)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.7
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTinacoAlt);
export default __webpack_public_path__ + "static/media/ico_tinaco_alt.742163e5c2c52999fe289762dea56139.svg";
export { ForwardRef as ReactComponent };